// extracted by mini-css-extract-plugin
export default {"radio_button_block":"styled_radio_button_block__ofXVQ","radio_button_label":"styled_radio_button_label__dJ5cg","radio_button_input":"styled_radio_button_input__bUthI"};